import { Link, withRouter } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Icon,
    Button,
    Input,
    Checkbox,
    message
} from 'antd';
import moment from 'moment';
import F from "../../../Functions";
import axios from 'axios';
import { Translate } from 'react-translated';

import React, { useState, useEffect } from 'react'
import { ADD_ROLES_API, GET_AGENCY_ID, GET_ROLES_API, GET_USER_DETAILS, IS_USER_EXISTS_API } from "../../../utils/Api_enums";
import { TYPE_OF_CALL } from "../../../utils/Constants";
import { useBoundStore } from "../../../store/useBoundStore";

const InviteScheduler = (props) => {
    const [loading, setLoading] = useState(false);
    const [agency_id, setAgency_id] = useState(null);
    const [loggedin, setLoggedin] = useState(props.auth.user);
    const [user, setUser] = useState({
        first_name: '',
        last_name: '',
        email: '',
        user_type: 'VONBOARDER'
    });
    const [checkTypeOFCall,setCheckTypeOFCall] = useState([]);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
          let user = useBoundStore.getState().userInfo;
          if(!user){
              axios.get("/api/user").then((res) => {
                  const u = res.data;
                  let agency_id = null;
                  for (let i = 0; i < u.user_agency_assoc.length; i++) {  // NOSONAR
                      agency_id = u.user_agency_assoc[i].agency_id;
                      break;
                  }
                  if (agency_id) {
                      setAgency_id(agency_id)
                  }
                  else {
                      // axios.post(`/api/get_agency_id${loggedin.user_type === 'SUPER_ADMIN' && '?user_type=BOBADMIN' || ''}`).then((res) => {
                      //     if (res && res.data && res.data.agency_id)
                      //         // this.setState({ agency_id:res.data.agency_id })
                      //         setAgency_id(res.data.agency_id)
                      // }
                      // )
                      axios.post(`${GET_AGENCY_ID}?user_type=BOBREVIEWADMIN`).then((res) => {
                          if (res && res.data && res.data.agency_id){
                              setAgency_id(res.data.agency_id)
                          }
                      }
                      )
                  }
      
              });
          }else {
            // axios.get("/api/user").then((res) => {
                  const u = user;
                  let agency_id = null;
                  for (let i = 0; i < u.user_agency_assoc.length; i++) { // NOSONAR
                      agency_id = u.user_agency_assoc[i].agency_id;
                      break;
                  }
                  if (agency_id) {
                      setAgency_id(agency_id)
                  }
                  else {
                      // axios.post(`/api/get_agency_id${loggedin.user_type === 'SUPER_ADMIN' && '?user_type=BOBADMIN' || ''}`).then((res) => {
                      //     if (res && res.data && res.data.agency_id)
                      //         // this.setState({ agency_id:res.data.agency_id })
                      //         setAgency_id(res.data.agency_id)
                      // }
                      // )
                      axios.post(`${GET_AGENCY_ID}?user_type=BOBREVIEWADMIN`).then((res) => {
                          if (res && res.data && res.data.agency_id){
                              setAgency_id(res.data.agency_id)
                          }
                      }
                      )
                  }
      
            //   });
          }

        }, [])
        

    useEffect(()=>{
        const getRoles = async()=>{
            const {data:{roles}} = await axios.get(GET_ROLES_API);
            setRoles(roles.map(item=>{
                return {
                    label: TYPE_OF_CALL[item.rolename], 
                    value: item.role_id, 
                    checked:false, 
                }
            }).reverse())
        }
        getRoles();
    },[])


    const updateField = (name, val) => {
        let cloneUser = { ...user };
        if(name==="first_name"){
            cloneUser[name] = val.replace(/[^a-zA-Z]/g, '');
            setUser(cloneUser);
        }else if(name==="last_name"){
            cloneUser[name] = val.replace(/[^a-zA-Z]/g, '');
            setUser(cloneUser);
        }else{
            cloneUser[name] = val;
            setUser(cloneUser);
        }
    }
    const  getUserRole = () =>{
        // Check conditions based on the call types array
        const rolesArr =  roles.filter(role => role.checked === true) .map(role => role.label);

        const hasReview = rolesArr.includes('Review');
        const hasLead = rolesArr.includes('Lead');
        const hasOpportunity = rolesArr.includes('Opportunity');
    
        // Define the roles based on the combinations of call types
        if (hasReview && !hasLead && !hasOpportunity) {
            return 'REVIEWSCHEDULER';
        } else if ((hasLead || hasOpportunity) && !hasReview) {
            // FS
            return 'VONBOARDER';
        } else if (hasReview && hasLead && !hasOpportunity) {
            return 'VONSCHEDULER';
        } else if (hasReview && !hasLead && hasOpportunity) {
            return 'VONSCHEDULER';
        } else if (hasReview && hasLead && hasOpportunity) {
            return 'VONSCHEDULER';
        }
    
        return ''; 
    }
    


    const invite = () => {
        if (user.email !== '' && user.first_name !== '' && user.last_name !== '') {
        
        if (!F.validateEmail(user.email)) {
            message.destroy();
            message.error(
                F.translate(`Please enter a valid email.`)
            );
            return 
        }

        const checkedRoles = roles.filter(
        (item) => item.checked === true
        );

        if(checkedRoles.length===0){
        message.destroy();
        message.error("Please select at least one type of call");
        return false;
        }

            // this.setState({ loading: true });
            setLoading(true);
            // axios.post("/api/is_user_exist", {
            // new api for is user exist 
            axios.post(IS_USER_EXISTS_API, {
                email: user.email
            }).then((res) => {
                // console.log("data==>",res.data)
                const {active,exist}= res.data;
                // const user_id = res.data;
                if (exist && active ) {
                    message.error(F.translate(`A user with this email already exists. Please try again with a different email`));
                    return;
                    // axios.post("/api/user_agency_assoc", {
                    //     agency_id: agency_id,
                    //     user_id: user_id
                    // }).then((res) => {
                    //     axios.post("/api/associations", {
                    //         parent_id: loggedin.id,
                    //         child_id: user_id,
                    //         status: 1
                    //     }).then((res) => {
                    //         message.success(F.translate(`Invite sent successfully`));
                    //         // this.setState({ loading: false }, () => {
                    //         //     this.props.history.push('/manage-users');
                    //         // });
                    //         setLoading(false);
                    //         props.history.push('/manage-users');
                    //     }).catch(() => {
                    //         message.error(F.translate(`Invitation not sent`));
                    //         setLoading(false);
                    //         // this.setState({ loading: false });
                    //     });
                    // }).catch((res) => {
                    //     message.error(F.translate(`Invitation not sent, please try again later.`));
                    //     // this.setState({ loading: false });
                    //     setLoading(false);
                    // });
                // checking if user already exists with email but currently not active in system 
                }else if(exist && !active){
                    message.error(F.translate(`The user exists with the given email but is currently inactive in the system.`));
                    return;
                }
                 else {

                    // axios.post(`/api/get_user_details${loggedin.user_type === 'SUPER_ADMIN' && '?user_type=BOBADMIN' || ''}`).then(res => {
                    //     axios.post(`/api/token${loggedin.user_type === 'SUPER_ADMIN' && '?user_type=BOBADMIN' || ''}`, {
                    //         first_name: user.first_name,
                    //         last_name: user.last_name,
                    //         email: user.email,
                    //         user_type: user.user_type,
                    //         invited_by: res.data.user_id
                    //     }).then((res) => {
                    //         axios.post("/api/user_agency_assoc", {
                    //             agency_id: agency_id,
                    //             user_id: res.data.id
                    //         }).then(() => {
                    //             message.success(F.translate(`Invite sent successfully`));
                    //             // this.setState({ loading: false }, () => {
                    //             //     this.props.history.push('/manage-users');
                    //             // });
                    //             setLoading(false);
                    //             props.history.push('/manage-users');
                    //         });
                    //     }).catch(() => {
                    //         message.error(F.translate(`Invitation not sent, please try again later.`));
                    //     });
                    // })

                    axios.post(`${GET_USER_DETAILS}?user_type=BOBREVIEWADMIN`).then(res => {
                        axios.post(`/api/token?user_type=BOBREVIEWADMIN`, {
                            first_name: user.first_name,
                            last_name: user.last_name,
                            email: user.email,
                            // user_type: "VONSCHEDULER", // here need to send user_type VONSCHEDULER
                            user_type: getUserRole(), // here need to send user_type VONSCHEDULER
                            invited_by: res.data.user_id
                        }).then((res) => {
                           
                              const checkedRoles = roles.filter(
                                (item) => item.checked === true
                              );
                            //  Type of Call for the Scheduler API CALL
                            axios.post(ADD_ROLES_API,{
                                user_id: res.data.id,
                                role_ids:checkedRoles.map(item=>item.value),
                            });

                            axios.post("/api/user_agency_assoc", {
                                agency_id: agency_id,
                                user_id: res.data.id
                            }).then(() => {
                                message.success(F.translate(`Invitation sent successfully`));
                                
                                // this.setState({ loading: false }, () => {
                                //     this.props.history.push('/manage-users');
                                // });
                                setLoading(false);
                                props.history.push('/manage-users-new');
                            });
                        })
                        .catch(() => {
                            message.error(F.translate(`Invitation not sent, please try again later.`));
                        });
                    })
                }

            }).catch(() => {
                message.error(F.translate(`Please try again later.`));
                // this.setState({ loading: false });
                setLoading(false);
            }).finally(() => {
                // this.setState({ loading: false });
                setLoading(false);
            });
        } else {
            message.error(F.translate(`Please fill all required fields.`));
            // this.setState({ loading: false });
            setLoading(false);
        }
    }


    const checkboxHandleChange = (e) => {
        const {value,checked} = e.target;
        const checkedValues = JSON.parse(value);

        
        // setCheckTypeOFCall(checkedValues)

        const updatedRoles = roles.map(item => 
            item.label === checkedValues.label && item.value === checkedValues.value
                ? { ...item, checked: checked }  
                : item
            );

            setRoles(updatedRoles)

    }
    // console.log('checkTypeOFCall = ', checkTypeOFCall);
    useEffect(()=>{
        getUserRole()
    },[roles])

    return (
        <div>
            <Card 
                type="inner"
                // title={''}
                title={<React.Fragment><Icon style={{ color: "#1890ff", marginRight: "5px"}} type="user-add" /> <Translate text={` Invite Schedulers`} /></React.Fragment>} 
                loading={loading}>
                <div>
                    <Row gutter={16}>
                        <Col md={8} span={24}>
                            <div className="inputField">
                                <label><Translate text={`First Name`} />     
                                 <span className="asteriskIcon">*</span>
                                </label>
                                <Input value={user.first_name} onChange={(e) => updateField('first_name', e.target.value)}
                                maxLength={30}
                                />
                            </div>
                        </Col>
                        <Col md={8} span={24}>
                            <div className="inputField">
                                <label><Translate text={`Last Name`} /> 
                                <span className="asteriskIcon">*</span>
                                </label>
                                <Input value={user.last_name} onChange={(e) => updateField('last_name', e.target.value)}
                                maxLength={30}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col md={16} span={24}>
                            <div className="inputField">
                                <label><Translate text={`Email`} /> 
                                <span className="asteriskIcon">*</span>
                                </label>
                                <Input value={user.email} onChange={(e) => updateField('email', e.target.value)} 
                                maxLength={250}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col md={16} span={24}>
                            <div className="inputField" >
                            <label style={{ display: "block", 
                                // padding: "10px 0px"
                                 }} ><Translate text={`Select Type of Call for the Scheduler `} /> 
                            <span className="asteriskIcon">*</span>
                            </label>
                            </div>
                            <div
                             style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "60%"
                            }}
                            >
                                {/* <Checkbox.Group
                                    className='invite-scheduler-checkboxes'
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "60%"
                                    }}
                                     options={roles}
                                     value={checkTypeOFCall} 
                                     onChange={checkboxHandleChange} /> */}

                                    {
                                    roles.map((role)=>{
                                        return(
                                        <Checkbox 
                                            key={role.value} 
                                            value={JSON.stringify(role)}
                                            checked={role.checked}
                                            onChange={checkboxHandleChange} 
                                            >
                                            {role.label}
                                        </Checkbox>
                                        )
                                    })
                                    }
                            </div>
                        </Col>
                    </Row>
                </div>
            </Card>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                }} >
                    {/* <Button type="default" shape='round' className='transparent-btn' >
                        <Translate text={`Cancel`} />
                    </Button>&nbsp;&nbsp; */}
                    <Button type="primary" shape='round' className='bg-color-164897'
                        onClick={invite}>
                        <Translate text={`Invite Schedulers`} />
                    </Button>
                </div>
            </div>
        </div>
    )
}


export default withRouter(InviteScheduler);



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/Invite Scheduler/InviteScheduler.js